import type { StandardItemEntryDto } from "@mimir/common/dto/itemModels";
import type { QuickPreview } from "../model/quickPreview";
import type { SearchState, UpdateSearchHitById } from "../model/searchState";
import type { LoadedItem } from "@mimir/common/dto/searchResultHit";
import { getItemFields } from "./api";
import { logErrorAndShowToast } from "./uiError";

export type UpdateSearchHitWithMediaPayload = {
  update: StandardItemEntryDto;
  quickPreview: QuickPreview,
  searchState: SearchState,
  updateItemDetailsItem: (update: UpdateSearchHitById) => void,
}

export async function updateSearchHitWithMedia(payload: UpdateSearchHitWithMediaPayload): Promise<void> {
  try {
    const retrievedFields: (keyof LoadedItem)[] = [
      'proxy', 'thumbnail', 'thumbnailStrip', 'itemState', 'transcodingState', 'mediaSize', 'mediaDuration',
      'hasEditProxy', 'hasProxy', 'editProxyIngested', 'editProxyAvailable', 'itemType', 'aaf', 'media',
      'editProxyFormat', 'id', 'proxySize', 'keldaIngest', 'highRes', 'editProxyUrl', 'mediaType', 'taskEntries',
    ];

    const partialItem = await getItemFields(payload.update.id, retrievedFields);
    const update: UpdateSearchHitById = {
      id: payload.update.id,
      update: partialItem,
      retrievedFields,
    };

    payload.searchState.ops.updateSearchHitById(update);
    payload.updateItemDetailsItem(update);
    payload.quickPreview.ops.updateCurrentPreviewItem(update);
  } catch (err) {
    logErrorAndShowToast('Was unable to update search hit with media details', err, 'ex in updateSearchHitWithMedia');
  }
  return;
}


